import React from 'react'

//Files
import word from './Ficha.docx'
import pdf from './Ficha.pdf'

const Enrollment = () => {

    return (
        <article className="eidefut-vision text-center">
          <h1 className="text-center mb-2">Pasos para inscripción</h1>
          <ol>
            <li className="mb-4">
              Solicitar información de costos de inscripción y mensualidad, 
              así como las cuentas bancarias, por los siguientes medios de contacto:<br/><br/>
                <div className="text-center">
                  <strong>Teléfonos:</strong> 0412-7400430 / 0426-5115741<br/>
                  <strong>Correo:</strong> clubeidefut@gmail.com
                </div>
            </li>
            <li className="mb-4">
              Realizar las transferencias por los montos indicados, a la cuenta indicada. 
              Guardar comprobante de la misma.
            </li>
            <li className="mb-4">
              Enviar al correo los siguientes documentos:<br/>
              <div className="text-center mt-2">
                <b>- Copia de la Partida de Nacimiento o Cédula del atleta<br/>
                - Copia de la Cédula del representante del atleta<br/>
                - Constancia de niño sano<br/>
                - Comprobantes de transferencias<br/>
                - Ficha de inscripción con los datos del atleta<br/></b>
                Descargar:  <a className="noColor" target="_blank"  rel="noopener noreferrer" 
                            href={pdf} download='Ficha de inscripción Eidefut'><b>PDF</b></a>&nbsp;
                            <a className="noColor" target="_blank"  rel="noopener noreferrer" 
                            href={word} download='Ficha de inscripción Eidefut'><b>Word</b></a><br/>
              </div>
            </li>
          </ol>
          </article>
          
        );
      }
export default Enrollment;